<app-preregister-operator-list-item
  body
  [preRegisterList]="preRegisterList"
  (operatorRegister)="addNewOperator($event)"
></app-preregister-operator-list-item>
